/* oxlint-disable typescript/no-unused-vars */
import { IEvent, IConsumer, createConsumer, createSubscriber } from '@cian/events-log';

import { TReduxActions, TThunkAction } from '../../types/redux';
import { getUserAction } from '../user/getUserAction';
import { getLkTypeAction } from '../lkType';
import { setReviewAllowed } from '../newReview';
import { reviewAllowedMapper } from '../../mappers/prepareReviews/reviewAllowedMapper';

export interface IRequestAuthenticationParameters {
  onSuccess?(): TThunkAction | TReduxActions;
  onCloseNoAuth?(): TThunkAction | TReduxActions;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return async (dispatch, getState, context) => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          const [user, lkType] = await Promise.all([dispatch(getUserAction()), dispatch(getLkTypeAction())]);
          dispatch(setReviewAllowed(reviewAllowedMapper(user, lkType)));

          /* istanbul ignore else */
          if (parameters && parameters.onSuccess) {
            dispatch(parameters.onSuccess());
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          /* istanbul ignore else */
          if (parameters && parameters.onCloseNoAuth) {
            dispatch(parameters.onCloseNoAuth());
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);

      /* istanbul ignore else */
      if (context.microfrontendsAPI) {
        await context.microfrontendsAPI.header.openAuthModal({ autoRefresh: false });
      }
    }
  };
}
